import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import OpensourceCharts from "../../containers/opensourceCharts/OpensourceCharts";
import Organizations from "../../containers/organizations/Organizations";
import PullRequests from "../../containers/pullRequests/PullRequests";
import Issues from "../../containers/issues/Issues";
import TopButton from "../../components/topButton/TopButton";
import "./Opensource.css";

class Opensource extends Component {
  render() {
    const showPageChrome = this.props.showPageChrome !== false;
    return (
      <div className="opensource-main">
        {showPageChrome ? <Header theme={this.props.theme} /> : null}
        <Organizations theme={this.props.theme} />
        <OpensourceCharts theme={this.props.theme} />
        <PullRequests theme={this.props.theme} />
        <Issues theme={this.props.theme} />
        {showPageChrome ? <Footer theme={this.props.theme} isDark={this.props.isDark} onToggle={this.props.onToggle} /> : null}
        {showPageChrome ? <TopButton theme={this.props.theme} /> : null}
      </div>
    );
  }
}

export default Opensource;
